export const normalizeMediaUrl = (url: string | null | undefined): string => {
  if (!url) return '';

  // Если уже относительный путь — возвращаем как есть
  if (url.startsWith('/')) {
    return url;
  }

  try {
    const parsed = new URL(url);
    return parsed.pathname + parsed.search;
  } catch {
    return url;
  }
};

export const normalizeIconUrl = (url: string | null | undefined): string => {
  if (!url) return '';

  // Если уже начинается с /static — возвращаем как есть
  if (url.startsWith('/static')) {
    return url;
  }

  // Если начинается с /icons (старый формат) — добавляем /static
  if (url.startsWith('/icons')) {
    return `/static${url}`;
  }

  // Если начинается с / — тоже оставляем как есть
  if (url.startsWith('/')) {
    return url;
  }

  try {
    const parsed = new URL(url);
    // Для иконок всегда возвращаем /static + pathname
    return `/static${parsed.pathname}${parsed.search}`;
  } catch {
    return url;
  }
};
